export default {"src":"/_next/static/media/vitejs.b0428eab.svg","height":257,"width":256,"blurWidth":0,"blurHeight":0};